"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (arr, key) {
    return arr.reduce(function (a, b) {
        var kv = b[key];
        var idx = a.findIndex(function (g) {
            return g.some(function (e) {
                return e[key] === kv;
            });
        });

        if (idx > -1) {
            a[idx].push(b);
        } else {
            a.push([b]);
        }
        return a;
    }, []);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/binary-utils/lib/array/groupArrayToNestedArray.js
// module id = 329
// module chunks = 0